<div>
  <span class="notification-item">
    NEW
  </span>
  <a class="text-xs">
    <ng-content></ng-content>
  </a>
</div>
